var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('TopBarOnlyLogo'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_vm._v("Orçamento B2B não disponível")]),_c('h1',{staticClass:"subTitle"},[_vm._v(" Tente novamente mais tarde ou contate o seu representante comercial ")])])
}]

export { render, staticRenderFns }